import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  container: {
    padding: theme.spacing(2, 0),
  },
}));
